import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { LoadupRequestFormBody } from "../components/LoadupRequestFormBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.LoadupRequestFormDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <LoadupRequestFormBody {...props} />
        </PageSkeleton>
    );
};
